import React from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions, DialogContent, DialogTitle, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from "src/utils/axios";
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const styles = {
    dialogTitle: {
        borderColor: '#FF9800',
        fontColor: '#FF9800',
        borderBottom: '2px solid orange'
    },
    title: {
        fontWeight: 'bold'
    }
};



const useStyles = makeStyles(() => ({
    root: {},
}));


function TamamlayiciHatirlatma({ anketOpen, setAnketOpen, anketTitle, BASVURU_NO, BIRIM_KODU, alinanSms, KUL_MODEL_KODU, setAnketKapandi }) {

    const classes = useStyles();
    const [oneriData, setOneriData] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [anketGoster, setAnketGoster] = useState(false);


    useEffect(() => {
        if (!anketOpen) {
            return;
        }
        setLoading(true);
        axios.get(`GetArtemisTamamlayiciUrunOneri/${BASVURU_NO || 0}/${BIRIM_KODU || 0}/${KUL_MODEL_KODU || 'A'}`)
            .then(response => {
                response.data.length === 0 ? setAnketGoster(false) : anketBaslat(response.data);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            });
    }, [BASVURU_NO, BIRIM_KODU, KUL_MODEL_KODU, alinanSms, anketOpen]);

    const anketBaslat = (data) => {
        if (data.length < 1) {
            setAnketGoster(false);
            return;
        }
        setOneriData(data);
        setAnketGoster(true);
    }



    const handleAnketKapat = () => {
        let job = loadBaslandiJob()[0];
        job = {
            ...job,
            TAMAMLAYICI_URUN_HATIRLATMA: 0
        };
        saveBaslandiJob(job);
        setAnketOpen(false);
        setAnketGoster(false);
        if (setAnketKapandi)
            setAnketKapandi(true);
    }







    return (
        <Dialog
            open={anketGoster}
            onClose={() => handleAnketKapat()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            
        >
            <DialogTitle id="alert-dialog-title"
                style={styles.dialogTitle}
            >
                <Typography
                    style={{ color: '#FF9800' }}
                >
                    {anketTitle}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {Loading ? (
                    <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
                ) : oneriData.length > 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <div style={{ marginRight: '10px' }}>
                            <DialogContent>
                                <img src={"/images/complemantaryimages/" + oneriData[0]?.RESIM + ".png"} alt="PerakendeTV" />
                            </DialogContent>
                        </div>
                        <div>
                            <Typography style={{ fontWeight: 'bold' }} gutterBottom className={classes.title}>
                                {oneriData[0]?.ACIKLAMA}
                            </Typography>
                            <Typography className={classes.title} gutterBottom>
                                {oneriData[0]?.METIN}
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                style={{ color: 'white', backgroundColor: 'black' }}
                                size="small"
                            >
                                {oneriData[0]?.KDVLI_FIYAT + ' TL'}
                            </Button>
                        </div>
                    </div>
                ) : null}
            </DialogContent>
            <DialogActions>
                {/* {anketBitti && */}
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => handleAnketKapat()}
                    style={{ color: 'white', backgroundColor: '#FF9800' }}
                >
                    Önerdim
                </Button>
                {/* } */}
            </DialogActions>
        </Dialog>
    );
}

export default TamamlayiciHatirlatma;
